import { render, staticRenderFns } from "./the-form-layout.vue?vue&type=template&id=23420480&scoped=true&"
import script from "./the-form-layout.vue?vue&type=script&lang=js&"
export * from "./the-form-layout.vue?vue&type=script&lang=js&"
import style0 from "./the-form-layout.vue?vue&type=style&index=0&id=23420480&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23420480",
  null
  
)

export default component.exports